import gql from 'graphql-tag'

export default gql`
  mutation CreateInterest(
    $name: String
    $email: String
    $phone: String
    $offerName: String
    $offerId: String
    $aereo: Boolean
    $traslado: Boolean
    $alquiler: Boolean
    $adults: Int
    $children: Int
    $checkIn: String
    $checkOut: String
  ) {
    createInterest(
      name: $name
      email: $email
      phone: $phone
      offerName: $offerName
      offerId: $offerId
      aereo: $aereo
      traslado: $traslado
      alquiler: $alquiler
      adults: $adults
      children: $children
      checkIn: $checkIn
      checkOut: $checkOut
    ) {
      id
    }
  }
`
